import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import classNames from "classnames";
import {CyClass} from "../../../../common/cy-classes";
import React from "react";
import {MobileLangSwitcherMenuItemSelectedLangBox} from "./boxes/mobile-lang-switcher-menu-item-selected-lang.box";
import {MobileLangSwitcherContainerBox} from "./boxes/mobile-lang-switcher-container.box";
import {MobileLanguageMenuItemBox} from "../boxes/mobile-language-menu-item.box";


export class MobileLangSwitcherMenuItemComponent extends OrbitComponent {
    render() {
        return (
            <MobileLangSwitcherContainerBox className="cy-menu-item" onClick={() => this.services.sideMenu.openMobileLanguageSwitcher()}>
                <MobileLanguageMenuItemBox className={CyClass('cy-lang-switch-label')}>
                    {this.services.translation.translate("LANGUAGES")}
                </MobileLanguageMenuItemBox>
                <MobileLangSwitcherMenuItemSelectedLangBox className={classNames(CyClass('cy-lang-switch-current-lang'))}>
                    {this.services.language.currentLanguage}
                </MobileLangSwitcherMenuItemSelectedLangBox>
            </MobileLangSwitcherContainerBox>
        );
    }
}